const data = {
  Items: [
    {
      Domain: 'mindfulchef.com',
      Duration: 0.025740732,
      EmailAddress: 'test@mindfulchef.com',
      IsComplainerOrFraudRisk: false,
      IsDisposableOrTemporary: false,
      ResponseCode: 'Valid',
      ResponseMessage: 'Email address was fully validated',
      UserAccount: 'test',
    },
  ],
}

export default data
